import { render, staticRenderFns } from "./rob.vue?vue&type=template&id=6085efc9&scoped=true&"
import script from "./rob.vue?vue&type=script&lang=js&"
export * from "./rob.vue?vue&type=script&lang=js&"
import style0 from "./rob.vue?vue&type=style&index=0&id=6085efc9&lang=less&scoped=true&"
import style1 from "./rob.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085efc9",
  null
  
)

export default component.exports